// extracted by mini-css-extract-plugin
export default {"header":"JTPem","header__title":"wKQHA","appear-from-above":"CjP01","appearFromAbove":"CjP01"};